import userStatisticActionTypes from '../actionTypes/userStatisticActionTypes';

const initialState = {
  statisticList: {},
  statisticIsLoading: false,
  aboutUser: null,
  aboutUserRaw: null,
  aboutUserLogo: null,
  aboutUserData: null,
  aboutUserIsLoading: false,
  setAboutUserIsLoading: false,
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case userStatisticActionTypes.GET_STATISTIC_START:
      return {
        ...state,
        statisticIsLoading: true,
      };
    case userStatisticActionTypes.GET_STATISTIC_SUCCESS:
      return {
        ...state,
        statisticList: payload,
        statisticIsLoading: false,
      };
    case userStatisticActionTypes.GET_STATISTIC_FAILURE:
      return {
        ...state,
        statisticList: payload,
        statisticIsLoading: false,
      };
    case userStatisticActionTypes.GET_ABOUT_START:
      return {
        ...state,
        aboutUserIsLoading: true,
      };
    case userStatisticActionTypes.GET_ABOUT_SUCCESS:
      return {
        ...state,
        aboutUser: payload.info,
        aboutUserRaw: payload.info_raw,
        aboutUserLogo: payload.shop_logo,
        aboutUserData: payload.user,
        aboutUserIsLoading: false,
      };
    case userStatisticActionTypes.GET_ABOUT_FAILURE:
      return {
        ...state,
        aboutUserIsLoading: false,
      };
    case userStatisticActionTypes.SET_ABOUT_START:
      return {
        ...state,
        setAboutUserIsLoading: true,
      };
    case userStatisticActionTypes.SET_ABOUT_SUCCESS:
      return {
        ...state,
        setAboutUserIsLoading: false,
      };
    case userStatisticActionTypes.SET_ABOUT_FAILURE:
      return {
        ...state,
        setAboutUserIsLoading: false,
      };
    default:
      return state;
  }
};

export default reducer;
